import React, { useContext } from 'react'
import { AuthContext } from '../AuthContext';

const AppBreadCrumb = (props) => {
    const { user } = useContext(AuthContext); // Get user data from context
  return (
    <>
       {/* Breadcrumb start */}
    <div className="row m-1">
      <div className="col-12 ">
        <h4 className="main-title">{props.title}</h4>
        <ul className="app-line-breadcrumbs mb-3">
          <li className>
            <a className="f-s-14 f-w-500" href="#">
              <span>
                <i className="ph-duotone  ph-stack f-s-16" /> {process.env.REACT_APP_NAME}
              </span>
            </a>
          </li>
          {/* <li>
            <a className="f-s-14 f-w-500" href="#">{user.organization.name}</a>
          </li> */}
          {[props.children]}
         
        </ul>
      </div>
    </div>
    {/* Breadcrumb end */}
    </>
  )
}

export default AppBreadCrumb
